// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// export const baseQuery = fetchBaseQuery({
//   baseUrl: process.env.REACT_APP_API_BASE || "",
//   credentials: "include", // send cookies (needed for server-set JWT cookie)
//   // prepareHeaders: (headers) => {
//   //   // optional: also set Authorization if you store token in storage
//   //   const token =
//   //     sessionStorage.getItem("userToken") || localStorage.getItem("token");
//   //   if (token) headers.set("Authorization", `Bearer ${token}`);
//   //   return headers;
//   // },

//   prepareHeaders: (headers, { endpoint }) => {
//     const token =
//       sessionStorage.getItem("userToken") || localStorage.getItem("userToken");

//     // Skip token for login / forgotPassword
//     const publicEndpoints = ["login", "forgotPassword", "resetPassword"];
//     if (token && !publicEndpoints.includes(endpoint)) {
//       headers.set("Authorization", `Bearer ${token}`);
//     }

//     headers.set("Accept", "application/json");
//     headers.set("Content-Type", "application/json");
//     return headers;
//   },
// });

// export const apiSlice = createApi({
//   baseQuery,
//   tagTypes: [`Academy`, `User`],
//   endpoints: (builder) => ({}),
// });

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../constants";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  credentials: "include",

  prepareHeaders: (headers, { endpoint, getState }) => {
    // Try to get token from Redux state first
    let token = getState()?.auth?.token;

    // If not in Redux state, try sessionStorage/localStorage as fallback
    if (!token) {
      token =
        sessionStorage.getItem("userToken") ||
        localStorage.getItem("userToken");
    }

    console.log(
      "🔍 prepareHeaders - endpoint:",
      endpoint,
      "token:",
      token ? "EXISTS" : "MISSING",
    );

    // Define public endpoints that don't need Authorization
    const publicEndpoints = ["login", "forgotPassword", "resetPassword"];

    // Attach token only for private endpoints
    if (token && !publicEndpoints.includes(endpoint)) {
      const authHeader = `Bearer ${token}`;
      headers.set("Authorization", authHeader);
      console.log("✅ Authorization header attached for endpoint:", endpoint);
      console.log("📝 Header value:", authHeader.substring(0, 50) + "...");
    } else if (!token) {
      console.log("⚠️ No token found in storage for endpoint:", endpoint);
    }

    // Set Accept header for all requests
    headers.set("Accept", "application/json");

    // Endpoints that use FormData should NOT have Content-Type set manually
    // This allows the browser to set the correct multipart/form-data boundary
    const formDataEndpoints = [
      "postRepairRequest",
      "postUploadImages",
      "uploadExcel",
      "postAcademy",
      "updateAcademy",
      "createUser",
      "updateUserImage",
      "completeRepairReport", // Add this line
      "completeMaintenanceReport", // Add this line
      "clockInOut", // Attendance clock in/out uses FormData with image upload
    ];

    if (!formDataEndpoints.includes(endpoint)) {
      if (!headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
      }
    } else {
      console.log(
        "📤 FormData endpoint detected, skipping manual Content-Type:",
        endpoint,
      );
    }

    return headers;
  },
});

// Wrapper to normalize rate-limit (429) responses so UI gets a friendly message.
const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (
    result.error?.status === "PARSING_ERROR" &&
    typeof result.error?.originalStatus === "number"
  ) {
    const { originalStatus, data } = result.error;
    if (originalStatus >= 200 && originalStatus < 300) {
      return { data: data ?? null };
    }
  }

  if (result.error && result.error.status === 429) {
    // Normalize to include a consistent message structure used across the app.
    return {
      error: {
        status: 429,
        data: {
          message:
            "You have reached the request rate limit. Please wait a minute and try again.",
        },
      },
    };
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery,
  tagTypes: [
    "Academy",
    "User",
    "feedback",
    "VendorCategories",
    "VendorCategory",
    "Vendors",
    "Vendor",
    "VisitLogs",
    "VisitLog",
    "Overtime",
    "Attendance",
    "AttendanceHistory",
    "AttendanceEntries",
    "AttendanceStatistics",
    "Calendar",
    "Calendars",
    "Holiday",
    "LeaveBalance",
    "Leave",
    "Asset",
  ],
  endpoints: (builder) => ({}),
});
